import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { connect } from 'react-redux'
import { FaRegTrashAlt } from 'react-icons/fa'

import {
  Btn,
  BtnIcon,
  CentraisOperacaoDropdown,
  CustomModal,
  OperadoresLogisticosDropdown,
} from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../../assets/js/styles'
import useModalAssocStretch, { LOAD_MESSAGE } from './ModalClienteTrechoHook'

function ModalClienteTrecho({ show, onModalClose, customer, dispatch }) {
  const { state, localDispatch } = useModalAssocStretch()

  const onClose = () => {
    localDispatch.resetState()
    onModalClose()
  }

  useEffect(() => {
    if (!customer) return
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_STRETCH:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.getTrechos(customer.id, state.centraloperacoes_id)
        break

      case LOAD_MESSAGE.SAVE_STRETCH:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.saveTrechos(customer.id, state.tp_id, state.centraloperacoes_id)
        break

      case LOAD_MESSAGE.DELETE_STRETCH:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.deleteTrechos(state.selectedStrechToDelete, state.centraloperacoes_id)
        break

      default:
        break
    }
  }, [state.loadingMessage, customer])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header={`Trechos: ${customer ? customer.nomeFantasia : ''}`}
      isVisible={show}
      onClose={onClose}
      width={600}
    >
      <div>
        <div className="p-grid">
          <div className="p-col-5">
            <CentraisOperacaoDropdown
              value={state.centraloperacoes_id}
              onChange={localDispatch.onCentralChange}
            />
          </div>
          <div className="p-col-4">
            <OperadoresLogisticosDropdown
              value={state.tp_id}
              onChange={localDispatch.onOperadorChange}
            />
          </div>
          <div className="p-col-3">
            <Btn
              onClick={() =>
                localDispatch.onBtnSalvarClicked(state.tp_id, state.centraloperacoes_id)
              }
            >
              Salvar Trecho
            </Btn>
          </div>
        </div>
        <DataTable
          value={state.associations}
          paginator={true}
          rows={5}
          emptyMessage="Nenhum trecho para exibir"
        >
          <Column field="step" header="Trecho" style={tableCellCentered()} />
          <Column field="tp_name" header="Operador Logístico" />
          <Column
            header=""
            style={tableCellCentered(80)}
            body={assoc => (
              <BtnIcon onClick={() => localDispatch.onBtnDeleteClicked(assoc.id)}>
                <FaRegTrashAlt color="red" size={18} />
              </BtnIcon>
            )}
          />
        </DataTable>
      </div>
    </CustomModal>
  )
}

export default connect()(ModalClienteTrecho)
